import { useQuery } from 'react-query';
import { fetchPrimeOriginals } from '../services/api';

export const usePrimeOriginals = options => {
  return useQuery('primeOriginals', fetchPrimeOriginals, options);
};
